var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39797_7202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_39797_7202)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E2E6F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_39797_7202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9089 48.5547H24.3221L17.2085 61.6269H61.7303L54.5618 48.5547H49.8926",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7303 63H17.2085L16 60.9678L23.1136 47.8955L24.3221 47.1815H28.9088V49.9278H25.1461L19.5156 60.2538H59.3957L53.7653 49.9278H49.8926V47.1815H54.5618L55.7702 47.8955L62.9388 60.9678L61.7303 63Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1173 31.006C52.1173 24.0305 46.4869 18.3732 39.4831 18.3732C32.4794 18.3732 26.8764 24.0305 26.8764 31.006V31.0884C26.8764 31.0884 25.8877 43.117 39.5106 52.7564C39.5106 52.7564 52.6941 44.2705 52.1448 31.0609V31.006H52.1173Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2522 53.8824H38.7141C24.5968 43.886 25.4482 31.5003 25.5031 30.951C25.5031 23.2615 31.7928 17 39.5106 17C47.2285 17 53.5181 23.289 53.5181 31.006V31.0609C54.0949 44.8472 40.829 53.5528 40.2522 53.9098V53.8824ZM39.5106 19.7463C33.3034 19.7463 28.2497 24.7994 28.2497 31.006C28.2222 31.6376 27.5631 42.1284 39.5106 51.0537C42.2022 49.049 51.211 41.5791 50.7715 31.1158V31.006C50.7715 24.7994 45.7178 19.7463 39.5106 19.7463Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4832 38.1739C43.4422 38.1739 46.6517 34.9648 46.6517 31.0061C46.6517 27.0475 43.4422 23.8384 39.4832 23.8384C35.5241 23.8384 32.3146 27.0475 32.3146 31.0061C32.3146 34.9648 35.5241 38.1739 39.4832 38.1739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4832 39.547C34.7865 39.547 30.9413 35.7022 30.9413 31.0061C30.9413 26.31 34.7865 22.4652 39.4832 22.4652C44.1798 22.4652 48.025 26.31 48.025 31.0061C48.025 35.7022 44.1798 39.547 39.4832 39.547ZM39.4832 25.2115C36.2971 25.2115 33.6879 27.8204 33.6879 31.0061C33.6879 34.1918 36.2971 36.8007 39.4832 36.8007C42.6692 36.8007 45.2784 34.1918 45.2784 31.0061C45.2784 27.8204 42.6692 25.2115 39.4832 25.2115Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39797_7202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_39797_7202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_39797_7202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.9388,
    height: 46,
    fill: "white",
    transform: "translate(16 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.867160a9c9f15d2c44450e8308b5b9cc.svg";
export { ForwardRef as ReactComponent };